import React, { PropsWithChildren } from "react";
import CustomButton from "../components/commonComponents/CustomButton";
import { BsArrowLeft } from "react-icons/bs";
import { matchPath, useNavigate } from "react-router-dom";
import DownloadAppBanner from "../components/commonComponents/DownloadAppBanner";
import { useAppSelector } from "../services/store";
import { getShowDownloadAppBanner } from "src/shared/redux-state/src";
import { useWindowWidth } from "../utilities/helpers";
import { usePreviousRoute } from "../guards/PreviousRouteContext";
import { AppRoutes } from "../navigation/routes";

type IProps = {
    fixedFooter?: boolean,
    title?: string,
    renderLayoutRightHtml?: () => JSX.Element,
    onBackClick?: () => void
}
const BackButtonLayout: React.FC<PropsWithChildren<IProps>> = ({ children, fixedFooter = false, title, renderLayoutRightHtml, onBackClick}) => {
    const navigate = useNavigate();
    const {previousRoute, canGoBackInApp} = usePreviousRoute();
    
    const showDownloadAppBanner = useAppSelector(getShowDownloadAppBanner);
    const width = useWindowWidth();

    return (
        <div className={`main-wrapper bg-white container ${showDownloadAppBanner ? (width > 567 ? 'pd-t-86' : 'pd-t-92') : 'pd-t-50'} ${fixedFooter ? 'pd-b-70' : 'pd-b-20'}`}>
            <div className={`header ${showDownloadAppBanner ? 'h-auto' : ''}`}>
                {showDownloadAppBanner ? <DownloadAppBanner /> : null}
                <div className='container h-100'>
                    <div className='row align-items-center h-100'>
                        <div className='col-sm-2 col-2 block-row-padding'>
                            <CustomButton icon={<BsArrowLeft size={24} />}
                                color="link"
                                onClick={() => {
                                    if(onBackClick) {
                                        onBackClick();
                                        return;
                                    }
                                    if (!previousRoute || previousRoute === AppRoutes.UNSUBSCRIBE_EMAILS || (previousRoute && previousRoute.includes('deep-link'))) {
                                        navigate(AppRoutes.HOME) 
                                    }
                                    else navigate(-1);
                                }}
                                title='Back'
                                customBtnStyle='custom-btn-icon' />
                        </div>
                        {title && 
                            <>
                                <div className={`col-sm-8 me-auto block-row-padding ${!renderLayoutRightHtml ? 'col-10' : 'col-7'}`}>
                                    <div className='fs-6 fs-xs-14 fw-semibold text-black mb-0 text-center text-truncate' style={{ left: width < 576 ?(!renderLayoutRightHtml ? '-14%' : '0') : '0', position: 'relative' }}>{title}</div>
                                </div>
                            </>
                        }
                        {renderLayoutRightHtml && renderLayoutRightHtml()}
                    </div>
                </div>
            </div>
            {children}
        </div>
    );
}

export default BackButtonLayout;